export const formatPrice = (price: string | number | null | undefined, locale: string): string => {
  if (price === null || price === undefined || price === '') return ''

  const amount = Number(String(price).replace(',', '.'))
  if (Number.isNaN(amount)) return String(price)

  return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(amount)
}
